/**
 * 移动端路由
 */
import { RouteRecordRaw } from "vue-router";

const MOBILE_PATH = "/mobile";
export const routesMobile: Array<RouteRecordRaw> = [
    {
        path: MOBILE_PATH,
        name: "Mobile",
        redirect: "/mobile/posts", //重定向到post列表页
    },
    {
        path: MOBILE_PATH + "/posts",
        name: "MobilePosts",
        component: () => import("@/mobile/postsHome.vue"), //home页，其实就是post列表页
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: true,
        },
    },
    {
        path: MOBILE_PATH + "/webhome",
        name: "MobileWebHome",
        component: () => import("@/mobile/webHome.vue"), //webhome页
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/posts/:id",
        name: "MobilePostDetail",
        component: () => import("@/mobile/postDetail.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/login",
        name: "MobileLogin",
        component: () => import("@/mobile/mobileLogin.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/search",
        name: "MobileSearch",
        component: () => import("@/mobile/mobileSearch.vue"), //全局搜索页
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/addpost",
        name: "MobileAddPost",
        component: () => import("@/mobile/addPost.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/medical",
        name: "MobileMedical",
        component: () => import("@/mobile/mobileMedical.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: true,
        },
    },
    {
        path: MOBILE_PATH + "/procedureDetail",
        name: "MobileProcedureDetail",
        component: () => import("@/mobile/mobileProcedureDetail.vue"),
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/doctordetail",
        name: "MobileDoctorDetail",
        component: () => import("@/mobile/mobileDoctotDetail.vue"),
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/clinicdetail",
        name: "MobileClinicDetail",
        component: () => import("@/mobile/mobileClinicDetail.vue"),
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/message",
        name: "MobileMessage",
        component: () => import("@/mobile/mobileMessage.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: true,
        },
    },
    {
        path: MOBILE_PATH + "/usercenter",
        name: "MobileUserCenter",
        component: () => import("@/mobile/mobileUserCenter.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: true,
        },
    },
    {
        path: MOBILE_PATH + "/user/profile",
        name: "MobileUserProfile",
        component: () => import("@/mobile/mobileMemberProfile.vue"),
        meta: {
            level: 1,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/medical/doctorappoints",
        name: "MobileDoctorAppoints",
        component: () => import("@/mobile/mobileDoctotAppoints.vue"), //医生预约管理设置列表
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/medical/userappoints",
        name: "MobileUserAppointments",
        component: () => import("@/mobile/mobileUserAppointments.vue"), //用户预约页面
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/user/appointslist",
        name: "MobileUserAppointmentsList",
        component: () => import("@/mobile/MobileUserAppointmentsList.vue"), //用户预约列表-我的预约
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
    {
        path: MOBILE_PATH + "/user/facetime",
        name: "MobileUserFaceTime",
        component: () => import("@/mobile/mobileUserFaceTime.vue"),
        meta: {
            level: 2,
            keepAlive: true,
            showNavBar: false,
        },
    },
];
